import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import Sidebar from '../layouts/Sidebar';
import Badge from '../components/ui/Badge';
import DataTable from '../components/ui/DataTable';
import DashboardService from '../services/DashboardService';

export default function Connectivity() {
  const [rows, setRows] = useState([]);

  const loadStatus = async () => {
    try {
      const response = await DashboardService.getConnectivity();
      if (response?.status === 200) {
        setRows(response.data.integrations.map((row, idx) => ({ id: idx, ...row })));
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadStatus();
    const intervalId = setInterval(loadStatus, 30000);
    return () => clearInterval(intervalId);
  }, []);

  const headCells = [
    { id: 'connection', label: 'Connection' },
    { id: 'dataFlow', label: 'Data Flow' },
    { id: 'status', label: 'Status', render: (row) => <Badge>{row.status}</Badge> },
    { id: 'lastSync', label: 'Last Sync' },
    {
      id: 'action',
      label: 'Action',
      render: (row) => (
        <button
          className="text-seha-500 text-xs font-medium hover:underline"
          onClick={() => {
            loadStatus();
            toast.success(`${row.connection} re-checked.`);
          }}
        >
          Test
        </button>
      ),
    },
  ];

  return (
    <Sidebar title="Connectivity">
      <section className="space-y-6">
        <DataTable title="System Connectivity Monitor" headCells={headCells} rows={rows} />
      </section>
    </Sidebar>
  );
}
